import React from 'react';
// Components
import RichTextRenderer from '../richTextRenderer';
// Interfaces
import { Text as TextInterface } from '../../interfaces/text';
interface SectionWithReferencesProps {
  sectionExtraClasses?: string;
  text: TextInterface;
  textExtraClasses?: string;
  children?: JSX.Element;
  referenceExtraClasses?: string;
}

function SectionWithReferences({
  sectionExtraClasses,
  text,
  textExtraClasses,
  children,
  referenceExtraClasses,
}: SectionWithReferencesProps) {
  return (
    <section className={`cl-section   ${sectionExtraClasses ? sectionExtraClasses : ''}`}>
      <div className='cl-section__bg'></div>
      <div className='cl-section__bg-decor'></div>
      <div className='cl-container'>
        <div className='cl-row'>
          {/* Text */}
          {text && (
            <div
              className={`cl-col cl-text-block cl-text-block--lg ${
                textExtraClasses ? textExtraClasses : ''
              }`}
            >
              <RichTextRenderer text={text} />
            </div>
          )}

          {/* Content Model Reference  */}
          {children ? (
            <div className={`cl-col ${referenceExtraClasses ? referenceExtraClasses : ''} `}>
              {children && children}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </section>
  );
}

export default SectionWithReferences;
